import React, { useState } from "react";

import Card from "./Card";

import theme, {
  navbarHeight,
  roundness,
  styles as commonStyles,
} from "../../../utils/styles";

import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

import data from "../../../data/projects";

const Projects = (props) => {
  const { yOffset, sectionIndex, isBreakpoint } = props;
  const documentHeight = window.innerHeight * sectionIndex;
  let scrolledInPercentage = Math.floor((yOffset / documentHeight) * 100);

  // console.log(scrolledInPercentage);

  const [buttonHover, setButtonHover] = useState({ next: false, prev: false });

  const [hover, setHover] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);

  const [revealDirection, setRevealDirection] = useState(null);

  const carouselLength = 3;
  const [carouselArrayIndexes, setCarouselArrayIndexes] = useState(
    Array.from({ length: carouselLength }, (x, i) => i)
  );

  const nodes = data.map((project, index) => {
    return (
      <div
        onMouseEnter={(e) => {
          setHover(true);
          setHoverIndex(index);
        }}
        onMouseLeave={(e) => {
          setHover(false);
          setHoverIndex(null);
        }}
        key={index}
      >
        <Card
          data={project}
          index={index}
          hoverIndex={hoverIndex}
          hover={hover}
          revealDirection={revealDirection}
          carouselArrayIndexes={carouselArrayIndexes}
          isBreakpoint={isBreakpoint}
        />
      </div>
    );
  });

  const carouselArray = (carouselArrayIndexes) =>
    Array.from({ length: carouselLength }, (x, i) => {
      if (isBreakpoint) {
        if (i === 0 || i === 2) {
          return null;
        }
      }
      return nodes[carouselArrayIndexes[i]];
    });

  const handlePrev = (e) => {
    let temp = [...carouselArrayIndexes];
    temp.pop();

    let prevIndex = temp[0] - 1;

    if (prevIndex < 0) {
      prevIndex = nodes.length - 1;
    }

    temp.unshift(prevIndex);
    setCarouselArrayIndexes(temp);
    setRevealDirection("left");
  };

  const handleNext = (e) => {
    let temp = [...carouselArrayIndexes];
    temp.shift();

    let nextIndex = temp[temp.length - 1] + 1;

    if (nextIndex > nodes.length - 1) {
      nextIndex = 0;
    }

    temp.push(nextIndex);
    setCarouselArrayIndexes(temp);
    setRevealDirection("right");
  };

  // console.log("indexes", carouselArrayIndexes);
  // console.log("nodes", carouselArray(carouselArrayIndexes));

  return (
    <div id="#projects" style={styles.root}>
      {isBreakpoint ? null : (
        <Fade when={scrolledInPercentage > 70} bottom>
          <div style={commonStyles.sectionHeading}>Our Projects</div>
        </Fade>
      )}
      <Slide when={scrolledInPercentage > 70} left>
        <div style={styles.container(isBreakpoint)}>
          {carouselArray(carouselArrayIndexes)}
        </div>
      </Slide>
      <Slide when={scrolledInPercentage > 70} left>
        <div style={styles.buttonContainer(isBreakpoint)}>
          <button
            style={styles.button(buttonHover.prev, isBreakpoint)}
            onClick={(e) => handlePrev(e)}
            onMouseEnter={(e) => {
              setButtonHover({ prev: true });
            }}
            onMouseLeave={(e) => {
              setButtonHover({ prev: false });
            }}
          >
            {/* {buttonHover.prev ? "Prev" : "←"} */}Prev
          </button>
          <button
            style={styles.button(buttonHover.next, isBreakpoint)}
            onClick={(e) => handleNext(e)}
            onMouseEnter={(e) => {
              setButtonHover({ next: true });
            }}
            onMouseLeave={(e) => {
              setButtonHover({ next: false });
            }}
          >
            {/* {buttonHover.next ? "Next" : "→"} */}Next
          </button>
        </div>
      </Slide>
    </div>
  );
};

export default Projects;

const transition = "ease-in-out 0.3s";

const styles = {
  root: {
    minHeight: "100vh",
    background: theme.colors.background,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
  },
  container: (isBreakpoint) => ({
    borderStyle: isBreakpoint ? "solid none none none" : "solid none",
    borderColor: "#ffffff00",
    borderWidth: isBreakpoint ? navbarHeight * 1.5 : navbarHeight / 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    columnGap: navbarHeight / 2,
  }),
  buttonContainer: (isBreakpoint) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderStyle: "solid",
    borderColor: "#ffffff00",
    borderWidth: isBreakpoint ? navbarHeight / 2 : 0,
  }),
  button: (hover, isBreakpoint) => {
    let isHover = hover;
    if (isBreakpoint) {
      isHover = true;
    }
    return {
      transition: "width " + transition,
      marginLeft: 12,
      marginRight: 12,
      width: isHover ? 65 : 60,
      height: 30,
      borderStyle: "solid",
      borderColor: "white",
      borderWidth: 3,
      borderRadius: roundness.button,
      background: isHover ? theme.gradients.theme : "transparent",
      fontSize: "14px",
      color: isHover ? theme.colors.background : "white",
      textAlign: "center",
      cursor: "pointer",
    };
  },
};
